import '.e{flex-shrink:0;}.ssr-plugin'
import '.k{padding:1rem;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.c6{height:100%;}.ssr-plugin'
import '.c0{border:none;}.ssr-plugin'
import '.c1{background-color:transparent;}.ssr-plugin'
import '.fp{border-radius:0px;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.az{align-items:stretch;}.ssr-plugin'
import '.eg{position:sticky;}.ssr-plugin'
import '.fq{top:4rem;}.ssr-plugin'
import '.fr{z-index:7;}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.fs{padding-bottom:1rem;}.ssr-plugin'
import '.ay{margin-bottom:1rem;}.ssr-plugin'
import '.ft{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.aq{position:fixed;}.ssr-plugin'
import '.cs{top:0;}.ssr-plugin'
import '.c4{left:0px;}.ssr-plugin'
import '.c5{right:0px;}.ssr-plugin'
import '.fu{bottom:0px;}.ssr-plugin'
import '.fv{z-index:9999;}.ssr-plugin'
import '.fw{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.de{justify-content:flex-end;}.ssr-plugin'
import '.ci{flex:1;}.ssr-plugin'
import '.be{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="e k h c6 c0 c1 fp"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="l m az"
    >
      <div className="eg fq fr b2 fs ay ft l"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="aq cs c4 c5 fu fv b2 fw l m"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="k l de ft"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ci be">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
